import React from 'react';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';
import ThirdPartyJobPaymentsAdmin from './ThirdPartyJobPaymentsAdmin';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ThirdPartyJobPaymentsAdminItem from '../../../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentsAdminItem';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import AuthService from '../../../../Services/authService';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';

export default class AllTpJobPaymentsTab extends ThirdPartyJobPaymentsAdmin {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      selectedItem: null,
    };

    if (props.tpJob && props.tpJob.TpJobId) {
      ThirdPartyJobPaymentsService.IsNewPaymentRequestButtonEnabled(props.tpJob.TpJobId)
        .then((result) => {
          this.setState({ isNewPaymentRequestEnabled: result });
        })
        .catch(() => {
          ErrorMessage.SetErrorMessage('ATPJPT31');
        });

      ThirdPartyJobPaymentsService.IsNewAdvancePaymentButtonEnabled(props.tpJob.TpJobId)
        .then((result) => {
          this.setState({ isNewAdvancePaymentEnabled: result });
        })
        .catch(() => {
          ErrorMessage.SetErrorMessage('ATPJPT39');
        });
    }

    ThirdPartyJobPaymentsAdminItem.statusChangeFunction = this.statusChangeFunction.bind(this);
  }

  getType() {
    return 'all_payments';
  }

  clickOnNewPaymentRequest(selectedId, selectedItem) {
    this.setState({ shownPanel: ShownPanelsEnum.AddNewItem });
  }

  clickOnNewAdvancePayment(selectedId, selectedItem) {
    this.setState({ shownPanel: ShownPanelsEnum.AddNewSubItem });
  }

  renderActionButtons() {
    const actionsDisabled = !this.state.itemList.find(
      (payment) => payment.Selected && payment.TypeText !== 'Payment Request'
    );
    const reissueDisabled =
      actionsDisabled || this.state.itemList.some((payment) => payment.TypeText === 'Advance Payment');

    const userOfficeId = AuthService.getInstance().GetLoggedInUser().officeId;

    // prettier-ignore
    const areOfficesTheSame =
      AuthService.IsAdmin()
      ? true
      : !this.props.tpJob
        ? false
        : OfficeHelper.IsSameOfficeGroup(userOfficeId, this.props.tpJob.FieldworkOfficeId);

    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa-regular fa-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnNewPaymentRequest(),
            tooltip: 'New Payment Request',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: !this.state.isNewPaymentRequestEnabled,
            hidden: !this.props.newButtonsEnabled,
          },
          {
            iconName: 'fa-regular fa-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnNewAdvancePayment(),
            tooltip: 'New Advance Payment',
            roleKey: 'EvaluatorPayment_NewAdvancePaymentButton',
            disabled: !this.state.isNewAdvancePaymentEnabled || !areOfficesTheSame,
            hidden: !this.props.newButtonsEnabled,
          },
          {
            iconName: 'fa-regular fa-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList
                  .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                  .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                'Approve'
              ),
            tooltip: 'Approve',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: actionsDisabled,
            hidden: !this.props.newButtonsEnabled,
          },
          {
            iconName: 'fa-regular fa-xmark',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList
                  .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                  .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                'Void'
              ),
            tooltip: 'Void',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: actionsDisabled,
          },
          {
            iconName: 'fa-solid fa-rotate-right',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList
                  .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                  .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                'VoidAndReissue'
              ),
            tooltip: 'Void & Reissue',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: reissueDisabled,
          },
          {
            iconName: 'fa-solid fa-trash',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList
                  .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                  .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                'VoidAndSupress'
              ),
            tooltip: 'Void & Supress',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: actionsDisabled,
          },
        ]}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.popup}
        {this.renderActionButtons()}
        {this.renderPanels()}
        <TabOfDataTable
          type={ThirdPartyJobPaymentsAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ThirdPartyJobPaymentsService.GetTpEvaluatorTpJobPayments}
          convertDBItemsFunction={ThirdPartyJobPaymentsService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={this.getSearchParamsType()}
          clickOnStartSearch={this.startSearch}
          useClickOnClearAll={true}
          enableUrlPush={false}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          errorCode='APT93'
        />
      </div>
    );
  }
}
